import { useState, useEffect } from 'react'
import { detectInAppBrowser } from '@/lib/browser-detection'

interface UseInAppBrowserResult {
  isInAppBrowser: boolean | null
  browserType: string | null
}

/**
 * Custom hook to detect if the user is using an in-app browser.
 * Returns null during SSR/initial hydration, then the detection result.
 */
export function useInAppBrowser(): UseInAppBrowserResult {
  const [isInAppBrowser, setIsInAppBrowser] = useState<boolean | null>(null)
  const [browserType, setBrowserType] = useState<string | null>(null)

  useEffect(() => {
    const detection = detectInAppBrowser()
    setIsInAppBrowser(detection.isInAppBrowser)
    setBrowserType(detection.browserType)
  }, [])

  return { isInAppBrowser, browserType }
}
